import React from 'react';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { LinkButtonStyled, LinkStyled } from './styled';
export function CheckCompatibilityLink({ link, linkLabel, onClickHandler, checkCompatibilityLabel, }) {
    return link ? (React.createElement(LinkStyled, { to: link, onClick: onClickHandler }, linkLabel || checkCompatibilityLabel)) : (React.createElement(LinkButtonStyled, { onClick: onClickHandler, color: colorCoreBlack900Base }, linkLabel || checkCompatibilityLabel));
}
